angular.module('agreements')
    .component('agreementAccessGroupPicker', {
        require: {
            ngModelCtrl: 'ngModel'
        },
        bindings: {
            required: "<?",
            modelType: "<?",
            filterField: "<?",
            onChange: "&",
        },
        templateUrl: "app/agreements/access-group/picker.html",
        controller: function(AgreementAccessGroup) {
            const ctrl = this

            ctrl.$onInit = () => {
                ctrl.modelType = ctrl.modelType || "object"
                ctrl.required = ctrl.required || false
                ctrl.filterField = ctrl.filterField || false
                AgreementAccessGroup.autocomplete().$promise.then(items => ctrl.items = items)

                ctrl.ngModelCtrl.$render = () => ctrl.selected = ctrl.ngModelCtrl.$viewValue
                ctrl.ngModelCtrl.$formatters.push(modelValue => modelValue)
                ctrl.ngModelCtrl.$parsers.push(viewValue => ctrl.modelType === "id" ? viewValue.id : viewValue)
            }

            ctrl.onSelectionChanged = item => {
                ctrl.ngModelCtrl.$setViewValue(item)
                ctrl.ngModelCtrl.$validate()
                ctrl.ngModelCtrl.$render()
                if (angular.isFunction(ctrl.onChange())) {
                    ctrl.onChange()(item)
                }
            }
        }
    })
